import { getAddToCartPossibilityByAvailability as addToCartPossibility } from '~/assets/services/availability';

export default function ({ productData, storeSelected }) {
    const { price, availability, onlyInStore, notSaleableSeparately } = productData;
    return addToCartPossibility(availability) && ((price && price.value > 0) || !storeSelected) && !onlyInStore && !notSaleableSeparately;
}
